import IconButton from '@mui/material/IconButton';
import {AgyleAddNoteIcon} from '../../icons/agyle';
import {Tooltip} from '@mui/material';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import useOpenState from '../../../hooks/useOpenState';
import NewNoteDraggableModal from '../../notes/component/newNoteDraggableModal';
import {useDispatch, useSelector} from 'react-redux';
import {
    ctxForeOpenNewClinicalNote,
    ctxPatientType,
    setForeOpenNewClinicalNote,
} from '../../../store/reducers/patientContext';
import {getConfig} from '../../../util/configUtil';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    iconBackground: {
        backgroundColor: theme.palette.background.dialogBorder,
        borderRadius: 6,
    },
}));

const PatientAddNoteButton = ({patient, disableSave, pastAttendances}) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();

    // Selectors
    const patientType = useSelector(ctxPatientType);
    const forceOpen = useSelector(ctxForeOpenNewClinicalNote);

    const [isEditNoteOpen, openEditNote, closeEditNote] = useOpenState(false, true);

    // Config
    const showAllAttendance = getConfig('modules.clinicalNotes.showAllAttendance', false);
    const showAllNotes = !pastAttendances && showAllAttendance;

    // Clinical notes modal state
    const [noteTextBounds, setNoteTextBounds] = React.useState({
        left: -window.innerWidth + 840,
        right: 0,
        top: 0,
        bottom: window.innerHeight - 620,
    });

    useEffect(() => {
        forceOpen ? openEditNote() : closeEditNote();
    }, [forceOpen]);

    const handleToggle = () => {
        if (isEditNoteOpen) {
            closeEditNote();
            dispatch(setForeOpenNewClinicalNote(false));
        } else openEditNote();
    };

    return (
        <div>
            <Tooltip title={t('Add note')}>
                <span>
                    <IconButton
                        onClick={handleToggle}
                        className={classes.iconBackground}
                        color={isEditNoteOpen ? 'primary' : 'default'}
                        size="small"
                    >
                        <AgyleAddNoteIcon/>
                    </IconButton>
                </span>
            </Tooltip>

            <NewNoteDraggableModal
                open={isEditNoteOpen}
                onClose={handleToggle}
                patient={patient}
                patientType={patientType}
                disableSave={disableSave}
                showAllNotes={showAllNotes}
                customNoteTextBounds={noteTextBounds}
            />
        </div>
    );
};

export default PatientAddNoteButton;